import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/AdShareCard.css';

const AdShareCard = ({ share }) => {
  if (!share) return null;
  const line1 = share.line1 || share.title || '';
  const line2 = share.line2 || '';
  const inner = (
    <>
      <span className="ad-share-bar" aria-hidden="true" />
      {share.image ? (
        <img className="ad-share-thumb" src={share.image} alt="" />
      ) : (
        <span className="ad-share-thumb is-empty" aria-hidden="true" />
      )}
      <span className="ad-share-copy">
        {line1 ? <span className="ad-share-line1">{line1}</span> : null}
        {line2 ? <span className="ad-share-line2">{line2}</span> : null}
      </span>
    </>
  );

  if (!share.ad_id) {
    return <div className="ad-share-card">{inner}</div>;
  }

  return (
    <Link to={`/ad/${share.ad_id}`} className="ad-share-card" onClick={(event) => event.stopPropagation()}>
      {inner}
    </Link>
  );
};

export default AdShareCard;
